import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const TooltipContent = styled('div')`
    width: 344px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TooltipRow = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TypographyLink = styled('a')`
    font-family: inherit;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${COLORS.neutral_50};

    &:hover {
        color: ${COLORS.neutral_90};
    }
`;
